import React, { useContext } from 'react';

import { media } from 'context';
import { Button, Layout, Logo } from 'ds';
import { Props as LayoutProps } from 'ds/Layout';
import { actions } from 'store/ServicesRequest';
import { useAppDispatch } from 'store/hooks';

import ProgressFooter from './ProgressFooter';
import StepMobile from './StepMobile';
import { SERVICES_REQUEST_CONTENT_MAX_WIDTH } from './constants';
import { StepProps } from './types';

interface Props extends StepProps {
  paddingX?: number;
  textLayoutProps?: LayoutProps;
  mobileStyle?: 'bottomInput' | 'compact';
}

const StepContainer: React.FC<Props> = props => {
  const {
    children,
    step,
    nextHref,
    ctaDisabled,
    skippable,
    backHref,
    onSubmit,
    requestState,
    stepCompletedEventValue,
    stepCompletedEventValues,
    paddingX = 40,
    stepName
  } = props;
  const { xs, sm } = useContext(media);
  const dispatch = useAppDispatch();

  if (xs || sm) {
    return <StepMobile {...props} />;
  }

  return (
    <Layout flex height="100vh">
      <Layout
        equalWidth
        background="linear-gradient(86deg, rgba(0, 120, 255, 0.05) 0%, rgba(142, 95, 244, 0.05) 100%)"
        align="center"
        justify="center"
        position="relative"
      >
        <Layout maxWidth={568} flexGrow={1} align="center" height="100%">
          {children[0]}
        </Layout>
        <Layout position="absolute" top={40} left={40}>
          <Logo color="blue-500" />
        </Layout>
      </Layout>
      <Layout direction="column" justify="space-between" equalWidth>
        <Layout justify="flex-end" height={104} align="center" paddingRight={40}>
          <Button
            size="xs"
            type="secondary"
            text="Exit"
            onClick={() => dispatch(actions.setExitModalIsVisible(true))}
          />
        </Layout>
        <Layout justify="center" paddingX={paddingX}>
          <Layout flexGrow={1} maxWidth={SERVICES_REQUEST_CONTENT_MAX_WIDTH}>
            {children[1]}
          </Layout>
        </Layout>
        <ProgressFooter
          step={step}
          nextHref={nextHref}
          ctaDisabled={ctaDisabled}
          skippable={skippable}
          backHref={backHref}
          onSubmit={onSubmit}
          requestState={requestState}
          stepCompletedEventValue={stepCompletedEventValue}
          stepCompletedEventValues={stepCompletedEventValues}
          stepName={stepName}
        />
      </Layout>
    </Layout>
  );
};

export default StepContainer;
